import { ViewType } from '../../types';
import { Categories, SmartViewType } from '../../../genericGridSmartViews/types';

export function convertGenericViewConfigToGridViewConfig(viewConfig) {
  // the grid only understands 2 view types , default and custom. These are used to enable/disabled
  // action buttons (Save As, Save, Discard Changes)
  // so we need to convert our current view types to the types that the grid can understand
  let type = ViewType.CUSTOM;
  if (viewConfig.isReadOnly) {
    type = ViewType.DEFAULT;
  }
  return {
    id: viewConfig._id,
    type: type,
    label: viewConfig.label,
    isFavorite: viewConfig.isFavorite,
    isRecent: viewConfig.isRecent,
    isReadOnly: viewConfig.isReadOnly,
    filters: JSON.parse(viewConfig.specifics.filters),
    displayedColumns: viewConfig.specifics.displayedColumns,
    compactView: viewConfig.specifics.compactView,
    columnConfigs: viewConfig.specifics.columnConfigs,
    pageSize: viewConfig.specifics.pageSize,
  };
}

export function convertGridConfigToGenericConfig(viewConfig) {
  return {
    category: Categories.SAVED,
    type: SmartViewType.GRID_VIEW,
    specifics: {
      filters: viewConfig.filters,
      columnConfigs: viewConfig.columnConfigs,
      displayedColumns: viewConfig.displayedColumns,
      pageSize: viewConfig.pageSize,
      compactView: viewConfig.compactView,
    },
  };
}
